import { OnlineLessonDetail } from '@models/interfaces/online_lesson.interface';
import GCLASS_SERVICE_API from '@services/microservices/class.service';
import { AxiosResponse } from 'axios';

const GenieClassServices = {
  async getLessonDetail(
    subjectId: number,
    onlineLessonId: number,
    afterResponseReceived: (
      response: AxiosResponse<OnlineLessonDetail>,
    ) => void,
  ) {
    if (subjectId !== 0) {
      return await GCLASS_SERVICE_API.get<OnlineLessonDetail>(
        `online-class/${onlineLessonId}/${subjectId}/detail`,
      ).then(response => {
        afterResponseReceived(response);
      });
    }
  },
};

export default GenieClassServices;
